import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyConfluenceSmartCreationModal: LoadableType<Omit<unknown, 'flags'>> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceSmartCreationModal" */ './ConfluenceSmartCreationModal.tsx'
			)
		).ConfluenceSmartCreationModal,
});
